import { Col, DatePicker, Form, Select } from "antd";
import { useEffect, useState } from "react";
import {
  EXISTING_PO_MAP_LIST,
  GET_DIGITALIZATION_STYLES,
  PO_MAP_NEW_ENDPOINT,
  SEWING_LINES,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";
import CustomDatePicker from "common/CustomDatePicker";

const MachineIssuesFilter = ({ initialTableData }) => {
  // States for filter lists
  const [sewingList, setSewingList] = useState([]);
  const [machineLinesList, setMachineLinesList] = useState([]);
  const [machinesList, setMachinesList] = useState([]);
  const [faultTypesList, setFaultTypesList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [assignedStatusList, setAssignedStatusList] = useState([]);

  // Antd
  const { Option } = Select;

  const getFilterPrerequisites = async (filterValues = {}) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };
    const response = await getData(
      `/api/digitalization/machine-maintenance/machine-issues/filter-pre-requisites`,
      false,
      bodyData,
    );

    if (response && response?.data?.code === 200) {
      const data = response?.data?.data;

      // Set all dropdown data from the response
      setSewingList(data?.sewing_lines || []);
      setMachineLinesList(data?.machine_lines || []);
      setMachinesList(data?.machine_information || []);
      setFaultTypesList(data?.fault_types || []);

      // Convert status and assigned_status objects to arrays for dropdown
      const statusArray = Object.entries(data?.status || {}).map(
        ([key, value]) => ({
          id: key,
          name: value,
        }),
      );
      setStatusList(statusArray);

      const assignedStatusArray = Object.entries(
        data?.assigned_status || {},
      ).map(([key, value]) => ({
        id: key,
        name: value,
      }));
      setAssignedStatusList(assignedStatusArray);
    }
  };

  // Effects
  useEffect(() => {
    getFilterPrerequisites();
  }, []);

  return (
    <>
      <Col span={3}>
        <Form.Item label="Issue Date" name="issue_date">
          <CustomDatePicker />
        </Form.Item>
      </Col>

      <Col span={2}>
        <Form.Item label="Machines" name="machine_information_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Machine"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(machinesList) &&
              machinesList.map((machine) => (
                <Option value={machine.id} key={machine.id}>
                  {machine.machine_identifier}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={2}>
        <Form.Item label="Sewing Line" name="sewing_line_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Sewing Line"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(sewingList) &&
              sewingList.map((line) => (
                <Option value={line.id} key={line.id}>
                  {line.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Machine Line" name="machine_line_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Machine Line"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(machineLinesList) &&
              machineLinesList.map((line) => (
                <Option value={line.id} key={line.id}>
                  {line.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Fault Type" name="machin_fault_type_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Fault Type"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(faultTypesList) &&
              faultTypesList.map((fault) => (
                <Option value={fault.id} key={fault.id}>
                  {fault.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Status" name="status">
          <Select
            showSearch
            allowClear
            placeholder="Select Status"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(statusList) &&
              statusList.map((status) => (
                <Option value={status.id} key={status.id}>
                  {status.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Assigned Status" name="is_assigned">
          <Select
            showSearch
            allowClear
            placeholder="Select Assigned Status"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(assignedStatusList) &&
              assignedStatusList.map((status) => (
                <Option value={status.id} key={status.id}>
                  {status.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default MachineIssuesFilter;
